module.exports = __webpack_public_path__ + "img/unauthorized.4d11cde6.png";